export default __webpack_public_path__ + "static/media/guardianeshero.3c9ab722.jpg";